/** 基本校正の段階制 Fish 料金表（backend `fishUsage.ts` と同期） */
export const PROOFREADING_FISH_TIERS = [
  {
    minChars: 1,
    maxChars: 30_000,
    fish: 5_000,
  },
  {
    minChars: 30_001,
    maxChars: 100_000,
    fish: 7_000,
  },
  {
    minChars: 100_001,
    maxChars: 200_000,
    fish: 10_000,
  },
] as const;

/** 校正入力の文字数上限（backend `MAX_PROOFREADING_INPUT_CHARS` と同期） */
export const PROOFREADING_FISH_MAX_CHARS = 200_000;

export type ProofreadingFishTier = (typeof PROOFREADING_FISH_TIERS)[number];

export function formatProofreadingFishNumber(value: number, locale = "ja"): string {
  return value.toLocaleString(locale);
}

/**
 * ティア行の表示用パラメータ（i18n `tierRange` / `tierAmount` に渡す）。
 * 文言組み立ては呼び出し側の i18n に委譲する。
 */
export function getProofreadingFishTierLineParams(
  tier: ProofreadingFishTier,
  locale: string,
): { min: string; max: string; fish: string } {
  return {
    min: formatProofreadingFishNumber(tier.minChars, locale),
    max: formatProofreadingFishNumber(tier.maxChars, locale),
    fish: formatProofreadingFishNumber(tier.fish, locale),
  };
}
